export const styles = theme => ({
  gotoIcon: {
    marginRight: theme.spacing(1),
  },
  gotoBtnContainer: {
    [theme.breakpoints.up('md')]: {
      maxWidth: theme.spacing(98.2),
      margin: '0 auto',
    },
  },
  gotoBtnBox: {
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(0),
    },
  },
  backBtnContainer: {
    paddingBottom: 0,
  },
});
